//=include magnific-popup/dist/jquery.magnific-popup.min.js
//=include tools/svg.js

;(function($, window, undefined) {

    // Determine the popup content link
    var contentlink = $('.js-download-popup-link');
    // Determine the popup success link
    var successLink = $('.download-popup-link--success');
    // Determine the popup target class
    var target = $('.download-popup-target');
    // Determine the popup content target
    var contentTarget = $(contentlink.attr('href'));
    // Determine the form inputs
    var email = $('#js-download-email');
    var field = email.parent();
    var select = $('#js-select-download-all');

    var svg = new Svg();

    // Hide all popup targets
    target.addClass('mfp-hide');

    // Enable the content popup
    contentlink.magnificPopup({
        type: 'inline',
        mainClass: 'mfp--outside mfp--downloads',
        closeMarkup: '<button title="%title%" type="button" class="mfp-close" aria-label="Close">' + svg.render('close') + '</button>',
        callbacks: {
            beforeOpen: function() {
                contentTarget.find('.js-file-types').html(select.val());
            },
            open: function () {
                TRACKING.trackPageview('/support/downloads/technical-files-popup')
            },
            close : function() {
                resetValidation();
            }
        },
        // If the file type is not set, do not show the popup
        disableOn : function() {
            return select.val() != '';
        }
    });

    // Enable the success popup
    successLink.magnificPopup({
        type: 'inline'
    });

    validSelect();

    // Enable/disable the popup content link
    select.on('change', function(e) {
        validSelect();
    });

    // If the file type is not set, stop the click event from happening
    contentlink.on('click', function(e) {
        e.preventDefault();
    });

    $('#js-download-all-button')
        .on('click', function(e) {
            e.preventDefault();
            var emailValue = email.val();

            resetValidation();

            // Check if the email input value exists, and is valid
            if (!emailValue) {
                setValidation();
                return false;
            }

            $.ajax({
                    url: '/support/downloads/bulk-download',
                    type: 'post',
                    data: {email: emailValue, fileType: select.val()},
                    dataType: 'json'
                })
                .done(function(data) {
                    if ('error' == data.result.status) {
                        setValidation(data.result.message);
                    } else {
                        // If successful, reset the email input value, and show the success popup
                        email.val('');
                        successLink.click();

                        TRACKING.trackEvent('Technical Files - Download all', 'Download', select.val() + ' Files');
                    }
                });
        });

    // Add validation messages to form
    function setValidation(message) {
        message = message || 'Email Address is a required field';
        field.addClass('field-error');
        field.append('<p class="error">' + message + '</p>');
    }

    // Remove validation messages from form
    function resetValidation() {
        field.removeClass('field-error');
        field.find('.error').remove();
    }

    function validSelect() {
        if (select.val() != '') {
            contentlink.removeClass('button--disabled');
        }
        else {
            contentlink.addClass('button--disabled');
        }
    }

})(jQuery, window);
